const { t } = require("autobiz-translate");
const ENV = process.env.REACT_APP_ENV || "staging";

const apisB2bPlateform = {
  local: "https://trade.shakazoola.local/api",
  dev: "https://trade.shakazoola.local/api",
  staging: "https://stg-admin-trade.shakazoola.com/api",
  preprod: "https://ppr-admin-trade.shakazoola.com/api",
  prod: "https://admin-trade-v2.autobiz.com/api",
};
exports.apiB2bPlateform = apisB2bPlateform[ENV];
exports.apiHost = apisB2bPlateform[ENV].replace(/^https?:\/\//, ""); // Remove http:// or https://

const apisOffice = {
  local: "https://stg-office-api.shakazoola.com",
  dev: "https://stg-office-api.shakazoola.com",
  staging: "https://stg-office-api.shakazoola.com",
  preprod: "https://ppr-office-api.autobiz.com",
  prod: "https://office-api.autobiz.com",
};
exports.apiOffice = apisOffice[ENV];

const urlsOffice = {
  local: "http://localhost:3001",
  dev: "https://dev-office-connect.shakazoola.com",
  staging: "https://stg-office-connect.shakazoola.com",
  preprod: "https://ppr-office-connect.autobiz.com",
  prod: "https://office-connect.autobiz.com",
};
exports.urlOffice = urlsOffice[ENV];

exports.linkNewPassword = {
  fr: "https://www.autobiz-market.com/fr/mot-de-passe-oublie",
  it: "https://www.autobiz-market.com/it/password-dimenticata",
  pt: "https://www.autobiz-market.com/pt/forgotpassword",
  de: "https://www.autobiz-market.com/de/passwort-vergessen",
  nl: "https://www.autobiz-market.com/fr/mot-de-passe-oublie",
  en: "https://www.autobiz-market.com/fr/mot-de-passe-oublie",
  es: "https://www.sistemavo.es/has-olvidado-tu-contrasena",
};

const identityPoolIds = {
  local: "eu-west-1:6505e22b-5315-4260-80d8-65550855378f",
  dev: "eu-west-1:f9823600-f4b5-4759-889d-1b02c431135a",
  staging: "eu-west-1:f9823600-f4b5-4759-889d-1b02c431135a",
  preprod: "eu-west-1:78e88d38-c70d-4ca3-8438-408ddb4aede7",
  prod: "eu-west-1:e8cbcb21-aa17-41e1-bdfc-58c09cb55566",
};

exports.identityPoolId = identityPoolIds[ENV];

exports.region = "eu-west-1";

const staticContents = {
  local: "https://translations-host-dev.s3-eu-west-1.amazonaws.com/trade-app",
  dev: "https://translations-host-dev.s3-eu-west-1.amazonaws.com/trade-app",
  staging: "https://translations-host-dev.s3-eu-west-1.amazonaws.com/trade-app",
  preprod: "https://translations-host-prod.s3-eu-west-1.amazonaws.com/trade-app",
  prod: "https://translations-host-prod.s3-eu-west-1.amazonaws.com/trade-app",
};

const staticImages = {
  local: "https://b2b-pictures-prod.s3-eu-west-1.amazonaws.com",
  dev: "https://b2b-pictures-prod.s3-eu-west-1.amazonaws.com",
  staging: "https://b2b-pictures-prod.s3-eu-west-1.amazonaws.com",
  preprod: "https://b2b-pictures-prod.s3-eu-west-1.amazonaws.com",
  prod: "https://b2b-pictures-prod.s3-eu-west-1.amazonaws.com",
};

const s3Bucket = {
  local: "https://minio.shakazoola.local/api/v1/buckets/tradev2/objects/download?preview=true&prefix=upload_media",
  dev: "https://minio.shakazoola.local/api/v1/buckets/tradev2/objects/download?preview=true&prefix=upload_media",
  staging: "https://autobiz-trade-stg.s3-eu-central-1.amazonaws.com/upload_media",
  preprod: "https://tradev2-ppr.s3-eu-central-1.amazonaws.com/upload_media",
  prod: "https://autobiz-trade-prd.s3-eu-central-1.amazonaws.com/upload_media",
};

exports.staticContentUrl = staticContents[ENV];
exports.staticImagesUrl = staticImages[ENV];
exports.s3Bucket = s3Bucket[ENV];

exports.staticCache = "static-content";
exports.staticFiles = { locale: "locale.json" };

exports.contactEmails = {
  fr: "supportclientb2b@autobiz.com",
  es: "contactar@autobiz.com",
  pt: "contactar@autobiz.com",
  it: "supportoclienti@autobiz.com",
  uk: "support@autobiz.com",
  de: "support@autobiz.com",
  nl: "support@autobiz.com",
  at: "support@autobiz.com",
  cz: "support@autobiz.com",
  ch: "support@autobiz.com",
  ro: "support@autobiz.com",
  se: "support@autobiz.com",
  dk: "support@autobiz.com",
  pl: "support@autobiz.com",
  gr: "support@autobiz.com",
  ie: "support@autobiz.com",
  hu: "support@autobiz.com",
  fi: "support@autobiz.com",
  sk: "support@autobiz.com",
  no: "support@autobiz.com",
  be: "support@autobiz.com",
  lu: "support@autobiz.com",
};

exports.pdfLang = {
  fr: "fr",
  de: "de",
  es: "es",
  it: "it",
  pt: "pt",
  en: "en",
  default: "en",
};

exports.tagManagerArgs = {
  gtmId: "GTM-K4DKLSR",
};

exports.tradeHelpMail = "trade-help@autobiz.com";

const recaptchaAccess = {
  siteKeyVisible: "6LdYfUoeAAAAAAB_Pjo4JgJ0vxdgC_1LJwJFmh0B",
  siteKeyInvisible: "6LeUv_UdAAAAAMAOPBg9tuc27JsNZGwaaBCq_Q1s",
};
exports.recaptchaAccess = recaptchaAccess;

exports.didomiConfig = {
  apiKey: "cfad80dd-8fb6-43fa-a253-7156b52c2514",
  noticeId: "ATZaMPw2",
  config: {
    app: {
      name: "autobizTrade",
    },
  },
};

exports.zendeskConfig = {
  apiKey: "95647fe6-313e-48a9-97a8-e840b2c1a60e",
};

exports.linkPrivacy = {
  fr: "politique-de-protection-des-donnees",
  it: "politica-sulla-riservatezza",
  de: "datenschutzrichtlinie",
  en: "privacy-policy",
  es: "politica-de-confidencialidad",
  pt: "politica-de-privacidade",
};

const domains = {
  local: "localhost",
  dev: ".shakazoola.com",
  staging: ".shakazoola.com",
  preprod: ".autobiz.com",
  prod: ".autobiz.com",
};

exports.languages = {
  fr: "FR",
  de: "DE",
  es: "ES",
  it: "IT",
  en: "EN",
  pt: "PT",
  nl: "NL",
};

exports.domain = domains[ENV];

exports.datadogConfig = {
  applicationId: "8162cc39-a9b8-481b-8483-17cdb29cb8c3",
  clientToken: "pubd1fb8dcaecca7ef1aa6d76fb160fc55a",
  site: "datadoghq.eu",
  service: `trade-app-${ENV}`,
};

const privateKeyForUpload = {
  local: "d41d8cd98f00b204e9800998ecf8427e",
  dev: "ZLGF4YcCi02K9wgC1Hc3kaPBVZ2WxWnWa93T2BQo",
  staging: "ZLGF4YcCi02K9wgC1Hc3kaPBVZ2WxWnWa93T2BQo",
  preprod: "ZLGF4YcCi02K9wgC1Hc3kaPBVZ2WxWnWa93T2BQo",
  prod: "ZLGF4YcCi02K9wgC1Hc3kaPBVZ2WxWnWa93T2BQo",
};

exports.privateKeyForUploadImage = privateKeyForUpload[ENV];

const auth0CredentialURL = {
  local: {
    domain: "stg-login-office.shakazoola.com",
    clientId: "Kxu47HVOepkZ8xePhBfJT22CtyRUf8as",
  },
  dev: {
    domain: "stg-login-office.shakazoola.com",
    clientId: "Kxu47HVOepkZ8xePhBfJT22CtyRUf8as",
  },
  staging: {
    domain: "stg-login-office.shakazoola.com",
    clientId: "Kxu47HVOepkZ8xePhBfJT22CtyRUf8as",
  },
  preprod: {
    domain: "ppr-login-office.shakazoola.com",
    clientId: "6NETs0CkdDGa7SpzarTI8eeBVZsABgZT",
  },
  prod: {
    domain: "login-office.autobiz.com",
    clientId: "PWNp4vzmYfJCNdq1jLfF1ryYki6pVrZH",
  },
};

exports.auth0Credentials = auth0CredentialURL[ENV];

exports.contractMap = {
  SMART: t("smart_contract"),
  STLA: t("stla_contract"),
  AZ: t("autobiz_contract"),
};

const marketV2Url = {
  local: "https://stg-market.shakazoola.com/analyse",
  dev: "https://stg-market.shakazoola.com/analyse",
  staging: "https://stg-market.shakazoola.com/analyse",
  preprod: "https://ppr-market.shakazoola.com/analyse",
  prod: "https://market.autobiz.com/analyse",
};
exports.marketUrl = marketV2Url[ENV]

const accountsUrl = {
  local: "https://stg-accounts.shakazoola.com/api",
  dev: "https://stg-accounts.shakazoola.com/api",
  staging: "https://stg-accounts.shakazoola.com/api",
  preprod: "https://ppr-accounts.shakazoola.com/api",
  prod: "https://accounts.autobiz.com/api",
};

exports.ACCOUNTS_URL_BASE = accountsUrl[ENV];

exports.tradeLanguages = [
  {
    id: "b0111406-44b7-4dd8-be81-43914ec2b62e",
    language_iso2: "fr",
    flag: "🇫🇷",
  },
  {
    id: "d1cc1d31-ce08-4f19-8efc-5ca65880c43b",
    language_iso2: "es",
    flag: "🇪🇦",
  },
  {
    id: "7104cb7f-9491-410a-9d36-2ee75d38ff2d",
    language_iso2: "it",
    flag: "🇮🇹",
  },
  {
    id: "a6c0190d-88b3-42a3-8d2d-b6bd5520eedc",
    language_iso2: "pt",
    flag: "🇵🇹",
  },
  {
    id: "beb9ef98-9a20-4a56-9abb-8e9c2979ba19",
    language_iso2: "en",
    flag: "🇬🇧",
  },
  {
    id: "72d280d4-bf12-4a51-aa2e-796c90563426",
    language_iso2: "nl",
    flag: "🇳🇱",
  },
  {
    id: "2f5de7f7-b67c-4309-a34e-33e07f6237e8",
    language_iso2: "de",
    falg: "🇩🇪 ",
  },
];
